import type { RuleGroupType } from 'react-querybuilder';

import type { MoiVendorAssignmentRuleCreateParams } from '~/server_shared/openapi/data-contracts';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';

/** The add/edit rule form's field ids and values. A module of their own because the assignee fields
 *  read them as well as the dialog that renders those fields: importing them from the dialog would
 *  make the two modules import each other. */
export const FIELD_IDS = {
  ID: 'id',
  NAME: 'name',
  SUB_ORGANIZATION_IDS: 'sub_organization_ids',
  LOBS: 'lobs',
  ALL_LOBS: 'is_all_lobs',
  MOI_METHODS: 'moi_methods',
  ASSIGNEE_STRATEGY: 'assignee_strategy',
  CONTACT: 'contact',
  CONTACT_ID: 'contact_id',
  CONTACT_FULL_NAME: 'contact_full_name',
  CONTACT_ROLE: 'contact_role',
  IS_ENABLED: 'is_enabled',
  CONDITIONS_JSON: 'conditions_json',
} as const;

export type MoiAssigneeStrategy = MoiVendorAssignmentRuleCreateParams['assignee']['strategy'];

export interface MoiAssignmentRuleFormValues {
  id: number | null;
  name: string;
  sub_organization_ids: number[];
  /** Holds LOB keys, but `LobMultiSelectWithChipsFormik` also stores its numeric All sentinel
   *  (`ALL_ID = 0`) in this field, so the element type is not `string`. Use `isAllLobsSelected`
   *  to test for it rather than comparing against a literal. */
  lobs: (string | number)[];
  is_all_lobs: boolean;
  /** Method keys, or the All sentinel (`ALL_MOI_METHODS_OPTION.id`), which the field keeps exclusive
   *  of them. */
  moi_methods: string[];
  assignee_strategy: MoiAssigneeStrategy;
  /** `contact_id`, `contact_full_name` and `contact` are the three fields `ContactTextFieldFormik`
   *  writes for the field id `contact`. */
  contact_id: number | '';
  contact_full_name: string;
  /** The contact picked in this dialog. An edit opens with the stored contact's id and name only,
   *  so this stays `null` until the admin picks one. */
  contact: ContactFullModel | null;
  contact_role: string;
  is_enabled: boolean;
  /** Opaque RQB JSON tree written by the shared conditions builder. */
  conditions_json?: RuleGroupType | null;
}
